"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareSemver = exports.minimumCssVersion = void 0;
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const lodash_isequal_1 = __importDefault(require("lodash.isequal"));
exports.minimumCssVersion = {
    majorVersion: '1',
    minorVersion: '5',
    patchVersion: '28',
    hash: 'sha256-40tir79t6Eg7jOwzniRsB4rwwPeNHoNUS2lCoBwxFAA=',
};
// using state only to track css being loaded is not enough to support hot-loading
// after first onCssLoad isLoaded state will always be true even across unmount/mounts
let cssLoaded;
exports.compareSemver = (a, b) => {
    const aValues = [a.majorVersion, a.minorVersion, a.patchVersion];
    const bValues = [b.majorVersion, b.minorVersion, b.patchVersion];
    for (let i = 0; i < 3; i++) {
        if (aValues[i] === bValues[i]) {
            continue; // eslint-disable-line no-continue
        }
        if (aValues[i] < bValues[i]) {
            return -1;
        }
        return 1;
    }
    return 0;
};
class CssLoader extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            isLoaded: cssLoaded !== undefined ? cssLoaded : false,
        };
        this.onCssLoaded = () => {
            cssLoaded = true;
            this.setState({ isLoaded: true });
        };
        this.updateLink = () => {
            // updates our link with the new url
            const { overrideVersion } = this.props;
            // could use semVer, but this is a simple scenario and mcp css version number are simple
            const version = !overrideVersion || exports.compareSemver(exports.minimumCssVersion, overrideVersion) >= 0 ? exports.minimumCssVersion : overrideVersion;
            // eslint-disable-next-line max-len
            const url = `https://static.ux.cimpress.io/mcp-ux-css/${version.majorVersion}.${version.minorVersion}/development/${version.majorVersion}.${version.minorVersion}.${version.patchVersion}/css/mcp-ux-css.min.css`;
            Object.assign(this.cssLinkElement, {
                href: url,
                onload: this.onCssLoaded,
                onerror: this.onCssLoaded,
                rel: 'stylesheet',
                charSet: 'utf-8',
                integrity: version.hash,
                crossOrigin: 'anonymous',
            });
        };
    }
    componentDidMount() {
        // create and add link tag to the document head.
        // this was originally done using react-helmet, but that only allowed inline scripts for onload/onerror
        this.cssLinkElement = document.createElement('link');
        document.head.appendChild(this.cssLinkElement);
        this.updateLink();
    }
    componentDidUpdate(prevProps) {
        // update link with css only if the override changes.
        if (!lodash_isequal_1.default(prevProps.overrideVersion, this.props.overrideVersion)) {
            this.updateLink();
        }
    }
    componentWillUnmount() {
        this.cssLinkElement.parentNode.removeChild(this.cssLinkElement);
    }
    render() {
        return this.state.isLoaded ? this.props.children : null;
    }
}
exports.default = CssLoader;
CssLoader.propTypes = {
    overrideVersion: prop_types_1.default.shape({
        majorVersion: prop_types_1.default.string.isRequired,
        minorVersion: prop_types_1.default.string.isRequired,
        patchVersion: prop_types_1.default.string.isRequired,
        hash: prop_types_1.default.string.isRequired,
    }),
    children: prop_types_1.default.node,
};
